import styled from "@emotion/styled";
import { Button, Container, Grid, Typography, keyframes } from "@mui/material";
import React from "react";
import { AllImage } from "../styling/style";
import PhoneRight from '../assets/phone-right.png';
import PhoneLeft from '../assets/phone-left.png';
import CenterLogo from '../assets/header-center.png';
import Phones from '../assets/phones.png';
import Rock from '../assets/mainrock.png';
import { useEffect } from 'react'
import AOS from "aos";


const HeaderText = styled(Typography)`
    text-align: center;
    color: #FFFFFF;
    margin: auto;
    max-width: 80%;
    font-family: poppins-bold;
    letter-spacing: 1px;
    font-size: 4rem;
    line-height: 1.3;
    @media (max-width: 800px){
        font-size: 30px;
    }
`
const HeaderGrid = styled(Grid)`
    padding-top: 30px;
    position: relative;
`
const ImageGrid = styled(Grid)`
    align-items: center;
    display: flex;
    margin: auto;
    justify-content: center;
    overflow: hidden;
    @media (max-width: 599px){
        margin: 5% 0%;
    }
`
const ImageRight = styled(AllImage)`
    position: absolute;
    right: 25%;
    top: 80%;
    z-index: 2;
    animation: appearFromRight 2s forwards, continuousMove 2s linear infinite;
    opacity: 0;
  @keyframes appearFromRight {
    0% {
      right: 0%;
      opacity: 0;
    }
    100% {
      right: 25%;
      opacity: 1;
    }
  }
  @keyframes continuousMove {
    0%, 100% {
      transform: translateX(0);
    }
    50% {
      transform: translateX(-5px);
    }
  }
  @media (max-width: 1000px){
        display: none;
    }
`
const ImageLeft = styled(AllImage)`
    position: absolute;
    top: 120%;
    left: 30%;
    z-index: 1;
    animation: appearFromLeft 2s forwards, continuousMove 2s linear infinite;
    opacity: 0;
    @keyframes appearFromLeft {
        0% {
            left: 0%;
            opacity: 0;
        }
        100% {
            left: 30%;
            opacity: 1;
        }
    }
    @media(max-width: 1000px){
        display: none;
    }
`
const SmallPhoneImage = styled(AllImage)`
    display: none;
    @media (max-width: 1000px){
        display: block;
        max-width: 400px;
    }

`
const ImageCenter = styled(AllImage)`
    position: absolute;
    left: 40%;
    top: 80%;
    z-index: 1;
    animation: continuousMove 2s linear infinite;

    @keyframes continuousMove {
    0%, 100% {
      transform: translateX(0);
    }
    50% {
      transform: translateX(-1px);
    }
  }
  @media(max-width: 1000px){
        display: none;
    }
`
const PGRid = styled(Grid)`
    background-image: url(${Rock});
    padding: 41px 75px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position: absolute;
    top: 300%;
    text-align: center;
    left: 20%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    @media (max-width: 429px){
        left: 0%;
        top: 94%;
        margin: 10px;
        padding: 25px 35px 25px 20px;
    }
    @media (min-width: 430px) and (max-width: 599px){
        left: 2%;
        top: 91%;
        margin: 10px;
        padding: 30px 35px 25px 20px;
        margin: 40px;
    }
    @media (min-width: 600px) and (max-width: 739px){
        left: 2%;
        top: 110%;
        margin: 10px;
        padding: 30px 43px 25px 5px;
    }
    @media (min-width: 740px) and (max-width: 799px){
        left: 5%;
        top: 110%;
        margin: 10px;   
    }
    @media (min-width: 800px) and (max-width: 900px){
        left: 2%;
        top: 100%;
        margin: 10px;
        padding: 40px 60px;
    }

    @media (min-width: 900px) and (max-width: 1000px){
        left: 8%;
        top: 100%;
        margin: 10px;
    }
    @media (min-width: 1000px) and (max-width: 1199px){
        left: 12%;
        top: 280%;
        margin: 10px;
    }
    @media (min-width: 1200px) and (max-width: 1500px){
        left: 18%;
        top: 304%;
        margin: 10px;
    }
    @media (min-width: 1800px){
        left: 17%;
        top: 283%;
        margin: 10px;
    }
`
const PTestGrid = styled(Grid)`
    background-image: url(${Rock});
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    padding: 41px 75px;
    position: absolute;
    top: 300%;
    text-align: center;
    left: 20%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  @media (max-width: 429px) {
      left: 0%;
      top: 94%;
      padding: 32px 35px 25px 20px;
    }
    @media (min-width: 430px) and (max-width: 599px){
        left: 2%;
        top: 91%;
        margin: 10px;
        padding: 30px 45px 25px 20px;
        margin: 40px;
    }
  @media (min-width: 601px) and (max-width: 900px) {
      left: 2%;
      top: 100%;
      margin: 10px;
      padding: 40px 60px;
    }
    @media (min-width: 900px) and (max-width: 1000px){
        left: 8%;
        top: 100%;
        margin: 10px;
    }
`
const Typo = styled(Typography)`
    text-align: center;
    color: #FFFFFF;
    font-family: poppins-regular;
    font-size: 14px;
    max-width: 570px;
    text-align: center;
`
const ButtonStyle = styled(Button)`
    color: #000000;
    background-color: #FFFFFF;
    padding: 5px 35px;
    margin-top: 10px;
    text-transform: none;
    font-family: poppins-semibold;
    &:hover{
        background-color: #FFFFFF;
    }
`

const Header = () => {
    useEffect(() => {
        AOS.init({
          duration: 800,
          offset: 200,
        });
      }, []);
    
      useEffect(() => {
        AOS.refresh();
      });
    return(
        <Container maxWidth='lg' id='home'> 
            <Grid container sx={{position: 'relative'}}>
                <HeaderGrid xs={12} data-aos="fade-right">
                    <HeaderText variant="h1">Revolutionizing Token
Discovery on Telegram</HeaderText>
                </HeaderGrid>
                <ImageGrid xs={12}>
                    <ImageLeft maxw='300px' src={PhoneLeft} data-aos="fade-right" data-aos-offset="300"  className="animate" />
                    <ImageCenter maxw='300px' src={CenterLogo}/>
                    <ImageRight maxw='300px' src={PhoneRight} data-aos="fade-left" data-aos-offset="300" className="animate"/>
                    <SmallPhoneImage maxw='50%' src={Phones}  data-aos="fade-down" data-aos-offset="300" data-aos-easing="ease-in-sine"/>
                </ImageGrid>
                <PTestGrid xs={12}  data-aos="zoom-in" data-aos-easing="ease-out-cubic" data-aos-duration="1200">
                    <Typo variant="subtitle-1">Peachy Trader allows you to experience margin trading like never before. Optimize your cryptocurrency trading today.</Typo>
                    <ButtonStyle data-aos='fade-in' data-aos-duration="1500"variant="contained">Trade Now </ButtonStyle>
                </PTestGrid>
            </Grid>
        </Container>
    )
}
export default Header;